module.exports = __webpack_public_path__ + "static/media/loginBackground.b439af2a.png";